import React, { useState } from "react";
import styled from "styled-components";
import { DayPicker } from "react-day-picker";
import differenceInCalendarDays from "date-fns/differenceInCalendarDays";
import "react-day-picker/dist/style.css";
import { IconButton } from "styled_components/Common/IconButton";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;

const DayPickerStyle = styled.div`
  .rdp {
    --rdp-cell-size: 25px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    .rdp {
      --rdp-cell-size: 30px;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    .rdp {
      --rdp-cell-size: 40px;
    }
  }
`;

export const DayPickerReact = ({ setSelectedDay, closeModal }) => {
  const [selected, setSelected] = useState(null);
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  function setDay(value) {
    setSelected(value);
  }
  function isPastDate(date) {
    return differenceInCalendarDays(date, new Date()) < 0;
  }
  function closeDateModal() {
    if (selected !== null) {
      setSelectedDay(selected);
    }
    closeModal();
  }

  return (
    <DayPickerStyle>
      <IconButton
        enabled={true}
        id="icon-button"
        module={module}
        onClick={closeDateModal}
        style={{ cursor: "pointer" }}
      >
        <img data-cy="close-button" src={CloseIcon} alt="" />
      </IconButton>
      <DayPicker
        mode="range"
        numberOfMonths={1}
        selected={selected}
        onSelect={setDay}
        weekStartsOn={0}
        disabled={isPastDate}
        max={2}
      />
    </DayPickerStyle>
  );
};
